import { render, staticRenderFns } from "./APILogs.vue?vue&type=template&id=32761833&scoped=true"
import script from "./APILogs.vue?vue&type=script&lang=js"
export * from "./APILogs.vue?vue&type=script&lang=js"
import style0 from "./APILogs.vue?vue&type=style&index=0&id=32761833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32761833",
  null
  
)

export default component.exports